import { BigNumber } from 'bignumber.js';
import { isEmpty } from 'lodash';
import { runInAction } from 'mobx';

import ValueFormatter, { ButtonItem } from './ValueFormatter';

class NumberNullableFormatter extends ValueFormatter<number, string> {
	public parseValue(value: string | null): number | undefined | null {
		let result: number | null = null;
		if (!isEmpty(value) && value !== null) {
			result = new BigNumber(value.replace(',', '.')).toNumber();
		}
		return result;
	}

	public renderValue(value: number): string {
		let result: any = new BigNumber(value);
		if (value === null || value === undefined) {
			result = '';
		}
		return result.toString();
	}
	public getActionButtons(): Array<ButtonItem<(object: any, property: string, validate: (object: any, value: number | undefined | null) => boolean) => void>> {
		if (this.dontShowActionButtons) {
			return [];
		} else {
			return [
				{
					icon: 'cil-plus',
					title: '+1',
					onClick: (object: any, property: string, validate: (object: any, value: number | undefined | null) => boolean) => {
						this.changeValue(
							object[property],
							object,
							validate,
							(value: number) => {
								runInAction(() => {
									object[property] = value;
								});
							},
							1
						);
					}
				},
				{
					icon: 'cil-minus',
					title: '-1',
					onClick: (object: any, property: string, validate: (object: any, value: number | undefined | null) => boolean) => {
						this.changeValue(
							object[property],
							object,
							validate,
							(value: number) => {
								runInAction(() => {
									object[property] = value;
								});
							},
							-1
						);
					}
				},
				{
					icon: 'cil-x',
					title: 'Очистить поле',
					onClick: (object: any, property: string, validate: (object: any, value: number | undefined | null) => boolean) => {
						let value: number | undefined | null = this.parseValue('');
						if (validate(object, value)) {
							runInAction(() => {
								object[property] = value;
							});
						}
					}
				}
			];
		}
	}
}

export let numberNullableFormatter = new NumberNullableFormatter();

export default NumberNullableFormatter;
